(function () {
  document.addEventListener("DOMContentLoaded", function () {
    // ==============================
    // Selectors / Storage
    // ==============================
    var S = {
      popover: ".mobile-popover",
      trigger: ".mobile-popover__trigger",
      value: ".mobile-popover__value",
      panel: ".mobile-popover__panel",

      menus: ".custom-aside-menu",
      hasChildren: ".aside-item.has-children",
      toggle: ".aside-toggle",
      title: ".aside-title",
      submenu: ".submenu",
      links: "a"
    };

    var STORE_KEY = "custom_aside_labels_v1"; // stores per parent label + mobile label

    // ==============================
    // Helpers
    // ==============================
    function norm(text) {
      return (text || "").replace(/\s+/g, " ").trim();
    }

    function setText(el, text) {
      if (!el) return;
      var t = norm(text);
      if (!t) return;
      el.textContent = t;
    }

    function setExpanded(el, expanded) {
      if (!el) return;
      el.setAttribute("aria-expanded", expanded ? "true" : "false");
    }

    function setHidden(el, hidden) {
      if (!el) return;
      el.hidden = !!hidden;
    }

    function samePath(hrefA, hrefB) {
      // compare pathname only (ignore query/hash, ignore trailing slash)
      try {
        var a = new URL(hrefA, window.location.origin);
        var b = new URL(hrefB, window.location.origin);
        var pa = a.pathname.replace(/\/$/, "");
        var pb = b.pathname.replace(/\/$/, "");
        return pa === pb;
      } catch (e) {
        return false;
      }
    }

    function readStore() {
      try {
        var raw = localStorage.getItem(STORE_KEY);
        return raw ? JSON.parse(raw) : { parents: {}, mobile: "" };
      } catch (e) {
        return { parents: {}, mobile: "" };
      }
    }

    function writeStore(next) {
      try {
        localStorage.setItem(STORE_KEY, JSON.stringify(next));
      } catch (e) {
        // ignore
      }
    }

    // Key for a parent dropdown based on its ORIGINAL title (stable across pages)
    function parentKeyFromTitle(titleText) {
      return norm(titleText).toLowerCase();
    }

    // ==============================
    // Submenu state
    // ==============================
    function setSubmenuState(item, open) {
      var btn = item.querySelector(S.toggle);
      var submenu = item.querySelector(S.submenu);
      if (!btn || !submenu) return;

      item.classList.toggle("is-open", !!open);
      setExpanded(btn, !!open);
      setHidden(submenu, !open);
    }

    // ==============================
    // Init ALL MENUS (Desktop + Mobile)
    // ==============================
    var menus = document.querySelectorAll(S.menus);
    var store = readStore();

    for (var m = 0; m < menus.length; m++) {
      (function (menuEl) {
        // 1) Restore stored parent titles (desktop + mobile panels)
        var parentItems = menuEl.querySelectorAll(S.hasChildren);

        for (var i = 0; i < parentItems.length; i++) {
          var titleEl = parentItems[i].querySelector(S.title);
          if (!titleEl) continue;

          // Save the original title once for keying (dataset survives within page)
          if (!titleEl.dataset.originalTitle) {
            titleEl.dataset.originalTitle = norm(titleEl.textContent);
          }

          var key = parentKeyFromTitle(titleEl.dataset.originalTitle);
          if (store.parents[key]) {
            setText(titleEl, store.parents[key]);
          }
        }

        // 2) Open correct parent by URL match, else open first parent
        var openIndex = 0;
        var currentUrl = window.location.href;

        // Find a matching submenu link -> open its parent
        for (var a = 0; a < parentItems.length; a++) {
          var submenu = parentItems[a].querySelector(S.submenu);
          if (!submenu) continue;

          var links = submenu.querySelectorAll(S.links);
          var matched = false;

          for (var b = 0; b < links.length; b++) {
            var href = links[b].getAttribute("href");
            if (!href) continue;

            var abs;
            try {
              abs = new URL(href, window.location.origin).href;
            } catch (e) {
              continue;
            }

            if (samePath(abs, currentUrl)) {
              openIndex = a;
              matched = true;

              // Also set the parent title to the active submenu link and persist
              var titleEl2 = parentItems[a].querySelector(S.title);
              if (titleEl2) {
                if (!titleEl2.dataset.originalTitle) {
                  titleEl2.dataset.originalTitle = norm(titleEl2.textContent);
                }
                var key2 = parentKeyFromTitle(titleEl2.dataset.originalTitle);
                var nextTitle = links[b].textContent;

                setText(titleEl2, nextTitle);
                store.parents[key2] = norm(nextTitle);
                writeStore(store);
              }
              break;
            }
          }

          if (matched) break;
        }

        for (var sIdx = 0; sIdx < parentItems.length; sIdx++) {
          setSubmenuState(parentItems[sIdx], sIdx === openIndex);
        }

        // 3) Attach parent dropdown toggle handlers
        for (var t = 0; t < parentItems.length; t++) {
          (function (item) {
            var btn = item.querySelector(S.toggle);
            if (!btn) return;

            btn.addEventListener("click", function (e) {
              e.preventDefault();
              var willOpen = !item.classList.contains("is-open");
              setSubmenuState(item, willOpen);
            });
          })(parentItems[t]);
        }

        // 4) Delegate submenu link clicks: update parent title + persist
        menuEl.addEventListener("click", function (e) {
          var link = e.target && e.target.closest ? e.target.closest("a") : null;
          if (!link) return;
          if (!menuEl.contains(link)) return;

          // Only submenu links should change parent title
          if (!link.closest(S.submenu)) return;

          var parentItem = link.closest(S.hasChildren);
          if (!parentItem) return;

          var titleEl3 = parentItem.querySelector(S.title);
          if (!titleEl3) return;

          if (!titleEl3.dataset.originalTitle) {
            titleEl3.dataset.originalTitle = norm(titleEl3.textContent);
          }

          var key3 = parentKeyFromTitle(titleEl3.dataset.originalTitle);
          var clickedTitle = link.textContent;

          setText(titleEl3, clickedTitle);
          store = readStore(); // re-read to avoid overwriting other writes
          store.parents[key3] = norm(clickedTitle);
          writeStore(store);

          // allow navigation
        });
      })(menus[m]);
    }

    // ==============================
    // Mobile Popover (Open/Close + label persist)
    // ==============================
    var popovers = document.querySelectorAll(S.popover);

    for (var p = 0; p < popovers.length; p++) {
      (function (popoverEl) {
        var trigger = popoverEl.querySelector(S.trigger);
        var panel = popoverEl.querySelector(S.panel);
        if (!trigger || !panel) return;

        var valueEl = trigger.querySelector(S.value);

        function isOpen() {
          return trigger.getAttribute("aria-expanded") === "true";
        }

        function openPopover() {
          setExpanded(trigger, true);
          setHidden(panel, false);
        }

        function closePopover() {
          setExpanded(trigger, false);
          setHidden(panel, true);
        }

        // Toggle
        trigger.addEventListener("click", function (e) {
          e.preventDefault();
          e.stopPropagation();
          isOpen() ? closePopover() : openPopover();
        });

        // Outside click
        document.addEventListener("click", function (e) {
          if (!isOpen()) return;
          if (!popoverEl.contains(e.target)) closePopover();
        });

        // ESC
        document.addEventListener("keydown", function (e) {
          if (!isOpen()) return;
          if (e.key === "Escape") closePopover();
        });

        // Restore label on load: URL match first, else stored mobile label
        (function restoreMobileLabel() {
          var current = window.location.href;
          var links = panel.querySelectorAll(S.links);

          for (var i = 0; i < links.length; i++) {
            var href = links[i].getAttribute("href");
            if (!href) continue;

            var abs;
            try {
              abs = new URL(href, window.location.origin).href;
            } catch (e) {
              continue;
            }

            if (samePath(abs, current)) {
              setText(valueEl, links[i].textContent);
              store = readStore();
              store.mobile = norm(links[i].textContent);
              writeStore(store);
              return;
            }
          }

          store = readStore();
          if (store.mobile) setText(valueEl, store.mobile);
        })();

        // Update label on link click + persist + close
        panel.addEventListener("click", function (e) {
          var link = e.target && e.target.closest ? e.target.closest("a") : null;
          if (!link) return;
          if (!panel.contains(link)) return;

          setText(valueEl, link.textContent);

          store = readStore();
          store.mobile = norm(link.textContent);
          writeStore(store);

          closePopover();
          // allow navigation
        });
      })(popovers[p]);
    }
  });
})();
